import { IPersonalInformation } from 'src/interfaces/personal-info';
import { PersonalInfoActionType } from '../action-types';
import { PersonalInfoAction } from '../actions';

interface PersonalInfoState {
  loading: boolean;
  error: string | null;
  data: { personalInfo?: IPersonalInformation };
}

const initialState = {
  loading: false,
  error: null,
  data: {},
};

const reducer = (state: PersonalInfoState = initialState, action: PersonalInfoAction): PersonalInfoState => {
  switch (action.type) {
    case PersonalInfoActionType.PATCH_PERSONAL_INFO_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case PersonalInfoActionType.PATCH_PERSONAL_INFO_FAILURE:
      return {
        loading: false,
        error: action.payload,
        data: state.data,
      };
    case PersonalInfoActionType.GET_PERSONAL_INFO:
      return { loading: true, error: null, data: {} };
    case PersonalInfoActionType.GET_PERSONAL_INFO_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case PersonalInfoActionType.GET_PERSONAL_INFO_FAILURE:
      return {
        loading: false,
        error: action.payload,
        data: {},
      };
    default:
      return state;
  }
};

export default reducer;
